import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, Subscription, throwError, TimeoutError } from 'rxjs';

import { map, catchError, finalize, timeout } from 'rxjs/operators';
import { Router } from '@angular/router';

import { MessageService } from 'primeng/api';
import { SettingsService } from '../services/settings.service';
import { environment } from 'src/environments/environment';


@Injectable()

export class Interceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private messageService: MessageService,
        public _settingsService: SettingsService

    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let token = localStorage.getItem('token');

        let headers: { [key: string]: string } = {};
        
        let hostname = window.location.hostname;
        const isLocalHost = ['localhost', '127.0.0.1', '0.0.0.0'].includes(hostname);
        const ambienteHeader = environment.ambiente || null;

        // Verifica se é uma requisição de login (não adiciona header de ambiente no login)
        const isLoginRequest = request.url.includes('/login') && request.method === 'POST';

        // Adiciona o header de ambiente se estiver configurado no environment (exceto no login)
        if (ambienteHeader && !isLoginRequest) {
            headers['ambiente'] = ambienteHeader;
        }

        if (token && request.url.indexOf('https://viacep.com.br') === -1) {
           
            // const headers: { [key: string]: string } = {
            //     Authorization: `Bearer ${token}`,
            // };

            headers['Authorization'] = `Bearer ${token}`;
        
           
        
            
        }

        request = request.clone({
            setHeaders: headers,
        });

        this._settingsService.loading = true;

        const requestTimeoutMs = this.resolveRequestTimeoutMs(request.url);

        return next.handle(request).pipe(
            timeout(requestTimeoutMs),
            map((event: HttpEvent<any>) => {

                if (event instanceof HttpResponse) {

                    let message = '';
                    if (event.status == 201) {

                        if (event.body.message) {
                            message = event.body.message;
                        } else {
                            message = 'Registro salvo com sucesso';
                        }

                        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: `${message}` });

                    } else if (event.status == 500) {

                        message = 'Ocorreu um erro no sistema, entre em contato com o suporte.';
                        this.messageService.add({ severity: 'error', summary: 'Erro', detail: `${message}` });

                    } else if (event.status === 204) {
                        // 204 No Content: sucesso sem corpo (ex.: DELETE). Não exibir aviso nem acessar event.body
                    } else if (event.status === 202) {
                        // Aceito / enfileirado — a tela trata a mensagem (evita toast duplicado).
                    } else {

                        if (event.status !== 200 && event.body != null) {
                            message = event.body?.message;
                            if (message) {
                                this.messageService.add({ severity: 'warn', summary: 'Aviso', detail: `${message}` });
                            }
                        }

                    }
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                let message = (error.error?.message ? error.error.message : '');
                // let message = '';

                if (error instanceof TimeoutError || error.status === 0 || error.status === 504) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'A API não retornou resposta. Verifique a conectividade e tente novamente.',
                    });
                    return throwError(() => error);
                }

                if (error.status === 502 || error.status === 503) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: message || 'A API não retornou resposta. Tente novamente em instantes.',
                    });
                    return throwError(() => error);
                }

                switch (error.status) {
                    case 401:
                        {
                            this.messageService.add({ severity: 'warn', summary: 'Aviso', detail: `Sessão expirada, logue novamente no sistema` });

                            setTimeout(() => {
                                localStorage.clear();
                                this.router.navigate(['/login']);
                            }, 2000);

                            break;
                        }
                    case 405: {
                        this.messageService.add({ severity: 'warn', summary: 'Aviso', detail: `Usuário sem permisão pra acessar a pagina` });

                        setTimeout(() => {
                            localStorage.clear();
                            this.router.navigate(['/notfound']);
                        }, 2000);

                        break;
                    }
                    default:
                        {
                            if (error.status == 422) {
                                this.messageService.add({ severity: 'warn', summary: 'Aviso', detail: message });
                                break;
                            } else {
                                this.messageService.add({ severity: 'error', summary: 'Erro', detail: message || `Erro ao exeutar a ação, entre em contato com o suporte!` });
                                break;
                            }
                        }
                }

                // localStorage.setItem('loading', '0');
                return throwError(() => error);
            }),
            finalize(() => {
                this._settingsService.loading = false;
            })


        )

    }

    /** Timeouts por rota: padrão 30s; operações longas e polígonos têm janelas maiores. */
    private resolveRequestTimeoutMs(url: string): number {
        if (url.includes('/map/municipality-polygons/')) {
            return 120000;
        }
        if (url.includes('/integracao-envio/enviar')) {
            return 11 * 60 * 1000;
        }
        if (
            url.includes('/reconsolida/dados')
            || url.includes('/onixsat/buscar-por-data')
            || url.includes('/resumo-evento-dia/remake')
        ) {
            return 10 * 60 * 1000;
        }
        return 30000;
    }
}
